// extracted by mini-css-extract-plugin
export default {"container":"RewardsOnOrder_container__tli5e","rewardBox":"RewardsOnOrder_rewardBox__f8XUv","rewardIcon":"RewardsOnOrder_rewardIcon__jbRHJ"};